"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CookieHelper = (function () {
    function CookieHelper() {
    }
    CookieHelper.get = function (key) {
        var pair = document.cookie.match(new RegExp(key + '=([^;]+)'));
        return !!pair ? pair[1] : '';
    };
    return CookieHelper;
}());
exports.default = CookieHelper;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/helpers/cookie-helper.ts
// module id = 105
// module chunks = 0